import { compareDesc } from 'date-fns';
import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const calcolaPreventivi =  async (request, v="api1.0") => {

    const {data} = await getapiclient().post(`${v}.estimates/calculate`, {
        request: JSON.stringify(request)
    })

    logger.debug("preventivi calcolati", data);

    return data;
}

const ricalcolaPreventivo =  async (request, suppressErrors = false, v="api1.0") => {

    logger.debug("comportamento di default in caso di errori per ricalcolo preventivo", !suppressErrors);

    const {data} = await getapiclient().post(`${v}.estimates/recalculate`, { 
        request: JSON.stringify(request)
    }, {        
        suppressErrors
    })

    logger.debug("preventivo ricalcolato", request, data);

    return data;
}

const ricalcolaPreventivi =  async (request, suppressErrors = false, v="api1.0") => {

    logger.debug("comportamento di default in caso di errori per ricalcolo preventivo", !suppressErrors);

    const {data} = await getapiclient().post(`${v}.estimates/recalculateall`, { 
        request: JSON.stringify(request)
    }, {        
        suppressErrors
    })

    logger.debug("preventivo ricalcolato", request, data);

    return data;
}


/**
 * Dato un vecchio preventivo, controlla che la data di ritiro sia ancora valida
 * e che il prezzo sia uguale
 * 
 * @param {*} request 
 * @param {*} v 
 */
const validaPreventivo = async (request, v="api1.0") => {

    const {pickupdate: dataDaControllare} = request;
    const {pickupdate: dataValida} = ricalcolaPreventivo(request);

    //controllo che il vecchio preventivo abbia una data di ritiro successiva o uguale alla prima data utile di ritiro ottenuta dal nuovo preventivo
    const esitoDataRitiro = compareDesc(dataDaControllare, dataValida) <= 0

}

export {calcolaPreventivi, ricalcolaPreventivo, ricalcolaPreventivi}